export const ORIGEN_KEYS = ['instalador', 'cliente']
export const ORIGEN_KEYS_PRESCRIPTOR = ['prescriptor']
